import { useEffect, useState } from 'react';
import { DatePicker, Drawer, Select, Space, Typography } from 'antd';
import type { AiPageContext } from '@/utils/aiPageContextFromPath';
import type { ConversationMode } from '@/services/aiAgent.service';

const { Text } = Typography;

const MODE_OPTIONS = [
  { value: 'assistant', label: 'Assistant' },
  { value: 'analyst', label: 'Analyst' },
  { value: 'executive', label: 'Executive' },
];

export interface ContextDrawerProps {
  open: boolean;
  onClose: () => void;
  pageContext: AiPageContext;
  mode: ConversationMode;
  onModeChange: (mode: ConversationMode) => void;
  contextFilters: Record<string, unknown>;
  onContextFiltersChange: (filters: Record<string, unknown>) => void;
}

export function ContextDrawer({
  open,
  onClose,
  pageContext,
  mode,
  onModeChange,
  contextFilters,
  onContextFiltersChange,
}: ContextDrawerProps) {
  const [isMobile, setIsMobile] = useState(() => typeof window !== 'undefined' && window.innerWidth < 992);

  useEffect(() => {
    const onResize = () => setIsMobile(window.innerWidth < 992);
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);

  return (
    <Drawer
      title="Context & filters"
      placement={isMobile ? 'bottom' : 'right'}
      height={isMobile ? '55vh' : undefined}
      width={isMobile ? undefined : 360}
      open={open}
      onClose={onClose}
    >
      <Space direction="vertical" size="middle" style={{ width: '100%' }}>
        <div>
          <Text type="secondary" style={{ fontSize: 11, textTransform: 'uppercase' }}>
            Mode
          </Text>
          <Select style={{ width: '100%', marginTop: 4 }} value={mode} options={MODE_OPTIONS} onChange={onModeChange} />
        </div>
        <div>
          <Text type="secondary" style={{ fontSize: 11, textTransform: 'uppercase' }}>
            Active context
          </Text>
          <div style={{ marginTop: 4 }}>
            <Text style={{ fontSize: 12 }}>Module: {pageContext.module || 'general'}</Text>
          </div>
        </div>
        <div>
          <Text type="secondary" style={{ fontSize: 11, textTransform: 'uppercase' }}>
            Date range
          </Text>
          <DatePicker.RangePicker
            style={{ width: '100%', marginTop: 4 }}
            onChange={(_, dateStrings) => {
              onContextFiltersChange({
                ...contextFilters,
                fromDate: dateStrings[0] || undefined,
                toDate: dateStrings[1] || undefined,
              });
            }}
          />
        </div>
      </Space>
    </Drawer>
  );
}
